export type Diario = {
  id?: number;
  caminhoArquivo: string;
  dataPublicacao: string;
  descricao: string;
  nomeArquivo: string;
  numero?: number;
  dataInclusao?: string;
  erro?: string;
  edicaoExtra?: boolean;
  diarioId?: number;
  numeroSuplemento?: number;
  suspenso?: boolean;
};

export interface Diarios {
  diario: Diario[];
  paginaAtual: number;
  totalDePaginas: number;
  totalDeRegistros: number;
}

export interface PaginasDiarios {
  paginasDiario: Pagina[];
  paginaAtual: number;
  totalDePaginas: number;
  totalDeRegistros: number;
}

interface Pagina {
  caminhoArquivo: string;
  dataPublicacao: string;
  descricao: string;
  hiHighlight: Highlight;
  nomeArquivo: string;
  numero: string | number;
  ocorrenciasPorPagina: number;
  pagina: number;
}

interface Highlight {
  texto: string[];
  nomeArquivo: string;
  numero: string;
  ocorrenciasPorPagina: number;
  pagina: number;
}

export enum TipoBuscaEnum {
  'Busca Exata' = 1,
  'Ao menos uma palavra',
}

export enum TipoPesquisaEnum {
  geral = 0,
  numerica,
  textual,
  periodo,
}
